import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorRepComponent } from './vendor-rep.component';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { AuthGuard } from '@core/okta-auth.guard';
import { RouterModule, Routes } from '@angular/router';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldTabBarModule } from '@emerald-angular/tab-bar';
import { EmeraldInputModule } from '@emerald-angular/input';
import { EmeraldCardModule } from '@emerald-angular/card';
import { FormsModule } from '@angular/forms';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { EmeraldProgressIndicatorModule } from '@emerald-angular/progress-indicator';
import { EmeraldMenuModule } from '@emerald-angular/menu';
import { EmeraldDatepickerModule } from '@emerald-angular/datepicker';
import { EmeraldModalModule } from '@emerald-angular/modal';
import { EmeraldCheckboxModule } from '@emerald-angular/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { upcomingInterviews } from './upcoming-interviews/upcoming-interviews.component';
import { EmeraldPaginationModule } from '@emerald-angular/pagination';
import { NgChartsModule } from 'ng2-charts';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { ContractorsListComponent } from './contractors-list/contractors-list.component';
import { InterviewStatusComponent } from './interview-status/interview-status.component';
import { VendorContractorHeadcountComponent } from './vendor-contractor-headcount/vendor-contractor-headcount.component';
import { TimesheetCalendarComponent } from './timesheet-calendar/timesheet-calendar.component';
import { ContractorListFilterComponent } from '@shared/modals/contractor-list-filter/contractor-list-filter.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { VendorQuarterlyFeedbackComponent } from './quarterly-feedback/vendor-quarterly-feedback.component';
import { VendorQuarterlyFeedbackModule } from './quarterly-feedback/vendor-quarterly-feedback.module';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';
import { VendorContractorProfileComponent } from './vendor-contractor-profile/vendor-contractor-profile.component';
import { ContractorVendorHeadCountComponent } from './vendor-profile-page/app-contractor-vendor-head-count/app-contractor-vendor-head-count.component';
import { InterviewsStatusComponent } from './vendor-profile-page/interviews-status/interviews-status.component';
import { QuarterlyFeedbackComponent } from './vendor-profile-page/quarterly-feedback/quarterly-feedback.component';
import { RtoBarChartComponent } from './vendor-profile-page/quarterly-feedback/rto-bar-chart/rto-bar-chart.component';
import { VendorInfoComponent } from './vendor-profile-page/vendor-info/vendor-info.component';
import { VendorProfileComponent } from './vendor-profile-page/vendor-profile-page.component';
import { VendorTimesheetFilterComponent } from '@app/shared/modals/vendor-timesheet-filter/vendor-timesheet-filter.component';
import { ModalWrapperComponent } from '@shared/components/modal-wrapper/modal-wrapper.component';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { PerformanceEvalutionComponent } from './performance-evalution/performance-evalution.component';
import { SharedModule } from '@shared/shared.module';

const routes: Routes = [
  {
    path: 'vendorflow-dashboard',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: VendorRepComponent },
      { path: 'contractors-list', component: ContractorsListComponent },
      {
        path: 'vendor-rep/contractors-list',
        component: ContractorsListComponent,
      },
      {
        path: 'quarterly-feedback',
        component: VendorQuarterlyFeedbackComponent,
      },
      {
        path: 'quarterly-feedback/:vendorId',
        component: VendorQuarterlyFeedbackComponent,
      },
      {
        path: 'contractor-profile/:id',
        component: VendorContractorProfileComponent,
      },
      { path: 'vendors-profile/:vendorId/:vendorName', component: VendorProfileComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  declarations: [
    VendorRepComponent,
    upcomingInterviews,
    InterviewStatusComponent,
    TimesheetComponent,
    ContractorsListComponent,
    VendorContractorHeadcountComponent,
    VendorContractorProfileComponent,
    ContractorVendorHeadCountComponent,
    InterviewsStatusComponent,
    QuarterlyFeedbackComponent,
    RtoBarChartComponent,
    VendorInfoComponent,
    VendorProfileComponent,
    PerformanceEvalutionComponent,
  ],
  imports: [
    CommonModule,
    EmeraldButtonModule,
    RouterModule.forChild(routes),
    EmeraldPaginationModule,
    EmeraldDropdownModule,
    EmeraldIconModule,
    EmeraldTabBarModule,
    EmeraldInputModule,
    FormsModule,
    EmeraldDesignSystemModule,
    EmeraldProgressIndicatorModule,
    EmeraldMenuModule,
    EmeraldDatepickerModule,
    EmeraldModalModule,
    EmeraldCheckboxModule,
    ReactiveFormsModule,
    ContractorListFilterComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    TimesheetCalendarComponent,
    FileUploadComponent,
    VendorQuarterlyFeedbackModule,
    NgChartsModule,
    EmeraldCardModule,
    VendorTimesheetFilterComponent,
    ModalWrapperComponent,
    ConfirmationDialogComponent,
    SharedModule,
  ],
  exports: [
    VendorRepComponent,
    upcomingInterviews,
    TimesheetComponent,
    ContractorsListComponent,
    VendorContractorHeadcountComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VendorRepModule {}
